__turbopack_context__.v({
  "affixWrapper": "lindex-module-scss-module__UlfaTa__affixWrapper",
  "ant-dropdown-menu": "lindex-module-scss-module__UlfaTa__ant-dropdown-menu",
  "ant-dropdown-menu-item": "lindex-module-scss-module__UlfaTa__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "lindex-module-scss-module__UlfaTa__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "lindex-module-scss-module__UlfaTa__ant-dropdown-menu-title-content",
  "back-top-wrap": "lindex-module-scss-module__UlfaTa__back-top-wrap",
  "filterTableSelect": "lindex-module-scss-module__UlfaTa__filterTableSelect",
});
